/* ==========================================================================
   PAW POWER — HEADER BEHAVIOUR

   The mega menu opens on hover through CSS alone, so it works with no JS at
   all. This file adds the things CSS cannot do:

     - a scrolled state, so the bar condenses and (when transparent) becomes
       solid once it is over content rather than over the hero
     - tap-to-open on touch devices, where :hover would otherwise need two
       taps and would swallow the first one
     - Escape to close, and closing when focus or the pointer leaves

   Prestige's own drawers (cart, mobile menu) and search are untouched — they
   are still driven by theme.min.js through the data-action attributes in
   sections/header.liquid.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var nav = $('.PP-Nav');
  if (!nav) return;

  /* ----------------------------------------------------------------------
     Scrolled state
     ---------------------------------------------------------------------- */
  function initScrolled() {
    var ticking = false;

    function update() {
      ticking = false;
      nav.classList.toggle('pp-stuck', window.pageYOffset > 24);
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });

    update();
  }

  /* ----------------------------------------------------------------------
     Mega menu

     Pointer users get the CSS :hover behaviour. Touch users get an explicit
     toggle: the first tap on a parent link opens its panel instead of
     following the link, and a second tap follows it.
     ---------------------------------------------------------------------- */
  function initPanels() {
    var items = $$('[data-pp-nav-item]');
    if (!items.length) return;

    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var link = $('.PP-Nav__Link', item);
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (item) {
      var link = $('.PP-Nav__Link', item);
      if (!link) return;

      if (!canHover) {
        link.addEventListener('click', function (e) {
          if (item.classList.contains('is-open')) return; // second tap follows the link
          e.preventDefault();
          closeAll(item);
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        });
      }

      /* Keyboard: the panel is already shown by :focus-within, so this only
         keeps aria-expanded honest for assistive technology. */
      item.addEventListener('focusin', function () {
        closeAll(item);
        link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('focusout', function (e) {
        if (item.contains(e.relatedTarget)) return;
        link.setAttribute('aria-expanded', 'false');
      });

      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-open');
        link.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = $('.PP-Nav__Item.is-open');
      closeAll(null);
      if (open) {
        var link = $('.PP-Nav__Link', open);
        if (link) link.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAll(null);
    });
  }

  /* ----------------------------------------------------------------------
     Oversized footer wordmark

     It has to span the container exactly, edge to edge, whatever the client
     types into the setting. A vw font-size cannot do that - it is only
     correct for one particular character count, and overflows or leaves a
     gap for every other. So measure the text and solve for the size.
     ---------------------------------------------------------------------- */
  function initBigWordmark() {
    var box = $('.PP-Footer__Big');
    var text = $('.PP-Footer__BigText');
    if (!box || !text) return;

    var REFERENCE = 100; // px - measure at a known size, then scale

    function fit() {
      var style = window.getComputedStyle(box);
      var available = box.clientWidth
        - parseFloat(style.paddingLeft || 0)
        - parseFloat(style.paddingRight || 0);
      if (available <= 0) return;

      /* Measure inline-block: a block-level element reports its container's
         width, not its text's, which silently made every result wrong. */
      text.style.fontSize = REFERENCE + 'px';
      var measured = text.getBoundingClientRect().width;
      if (!measured) return;

      var size = REFERENCE * (available / measured);
      text.style.fontSize = Math.max(28, Math.min(400, size)) + 'px';
    }

    fit();

    /* Archivo Black almost certainly is not there on first paint, and it is
       much wider than the fallback, so re-fit once it lands. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fit).catch(function () {});
    }

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(fit, 120);
    }, { passive: true });
  }

  /* ----------------------------------------------------------------------
     Fit the navigation, or collapse it

     The centred pill only works while the logo, the menu and the action
     cluster all fit on one line. With a long menu - this store has eight
     items, several of them three words - they do not, and the grid pushes
     the logo off the left edge and the cart off the right, leaving the page
     scrolling sideways.

     A CSS breakpoint cannot decide this, because whether it fits depends on
     the merchant's menu, not the viewport. So measure it.
     ---------------------------------------------------------------------- */
  function initFit() {
    var inner = $('.PP-Nav__Inner', nav);
    var menu = $('.PP-Nav__Menu', nav);
    var left = $('.PP-Nav__Left', nav);
    var right = $('.PP-Nav__Right', nav);
    if (!inner || !menu || !left || !right) return;

    var ticking = false;

    function measure() {
      ticking = false;

      /* Measure uncollapsed, otherwise the menu is display:none and reports
         zero, which would latch the collapsed state on for ever. */
      nav.classList.remove('PP-Nav--collapsed');
      nav.classList.remove('PP-Nav--stacked');

      var style = window.getComputedStyle(inner);
      var available = inner.clientWidth
        - parseFloat(style.paddingLeft || 0)
        - parseFloat(style.paddingRight || 0);

      /* scrollWidth, not getBoundingClientRect: the flex children have already
         been squeezed by the grid, so their rendered width understates what
         they actually need. */
      var needed = left.scrollWidth + menu.scrollWidth + right.scrollWidth
        + (parseFloat(style.columnGap || style.gap || 0) * 2);

      var oneRowFits = needed <= available;

      /* Preferred: everything on one line. Next: the menu on its own row,
         which is what a long menu usually needs. Last: the burger, once even
         a full row cannot hold the menu. */
      if (oneRowFits) {
        nav.classList.remove('PP-Nav--stacked');
        nav.classList.remove('PP-Nav--collapsed');
      } else if (menu.scrollWidth <= available) {
        nav.classList.add('PP-Nav--stacked');
        nav.classList.remove('PP-Nav--collapsed');
      } else {
        nav.classList.remove('PP-Nav--stacked');
        nav.classList.add('PP-Nav--collapsed');
      }
    }

    measure();

    window.addEventListener('resize', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(measure); }
    }, { passive: true });

    /* Menu labels are set in the display font; it is wider than the fallback,
       so re-measure once it has actually loaded. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(function () {});
    }
  }

  function boot() {
    initScrolled();
    initPanels();
    initBigWordmark();
    initFit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
